import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-muted/30 border-t border-border/50 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-foreground transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-foreground transition">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-muted-foreground hover:text-foreground transition">
                  Success Stories
                </Link>
              </li>
              <li>
                <Link to="/partner" className="text-muted-foreground hover:text-foreground transition">
                  Partner With Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/full-curriculum" className="text-muted-foreground hover:text-foreground transition">
                  Curriculum
                </Link>
              </li>
              <li>
                <Link to="/mobile-app" className="text-muted-foreground hover:text-foreground transition">
                  Mobile App
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/dashboard/support" className="text-muted-foreground hover:text-foreground transition">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-foreground transition">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Connect</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://www.tiktok.com/@launchtorevenue" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition">
                  TikTok
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/launchtorevenue" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition">
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/@launchtorevenue" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition">
                  YouTube
                </a>
              </li>
              <li>
                <Link to="/" className="text-muted-foreground hover:text-foreground transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border/50 mt-12 pt-8 text-center space-y-2">
          <p className="text-muted-foreground">&copy; {new Date().getFullYear()} LaunchToRevenue™. All rights reserved.</p>
          <p className="text-sm text-muted-foreground/80">
            LaunchToRevenue™ — Your All-in-One Digital Business Ecosystem
          </p>
        </div>
      </div>
    </footer>
  );
};
